export default __webpack_public_path__ + "static/media/thirdPartyType.3bec40f0.svg";